import React, { useState } from 'react';

import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import { borderColor } from './common';

const EAA_Date = ({
  disabled = false,
  displayBorder = false,
  value = '',
  onChange = () => {},
  hint = '年 / 月 / 日',
  inputFormat = 'yyyy/MM/dd',
  openTo = undefined,
  marginRight = 50,
  error = false,
}) => {
  // console.log('EAA_Date', disabled, displayBorder, value, onChange, hint, inputFormat, openTo, marginRight, error);
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  const [open, setOpen] = useState(false);
  
  const views = [];
  if (inputFormat.match('yyyy'))views.push('year');
  if (inputFormat.match('MM'))views.push('month');
  if (inputFormat.match('dd'))views.push('day');
  let mask = inputFormat;
  while (mask.match('y'))mask = mask.replace('y', '_');
  while (mask.match('M'))mask = mask.replace('M', '_');
  while (mask.match('d'))mask = mask.replace('d', '_');

  return (
    <div style={{ flex: 1, marginRight }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          readOnly={disabled}
          views={views}
          mask={mask}
          inputFormat={inputFormat}
          openTo={openTo || views[0]}
          value={value}
          onChange={onChange}
          onOpen={() => { setFocus(true); setOpen(true); }}
          onClose={() => { setFocus(false); setOpen(false); }}
          open={disabled ? false : open}
          renderInput={params => (
            <TextField
              {...params}
              onClick={disabled ? () => {} : () => setOpen(true)}
              variant='standard'
              style={{
                backgroundColor: disabled ? '#ededed' : 'white',
                width: '100%',
                height: 46,
                textAlign: 'start',
                borderRadius: 14,
                border: ((displayBorder || over || focus || error) && !disabled) ? `1px solid ${(over || focus) ? 'black' : (error ? 'red' : borderColor)}` : '',
              }}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                style: {
                  width: '100%',
                  height: 46,
                  paddingLeft: 12,
                  paddingRight: 12,
                  fontSize: 16,
                  letterSpacing: '0.15px',
                  fontWeight: (value !== '') ? 500 : '-moz-initial',
                  color: error ? 'red' : 'black',
                },
              }}
              inputProps={{
                ...params.inputProps,
                placeholder: hint,
                readOnly: true,
                value: typeof (value) === 'object' ? params.inputProps.value : '',
              }}
              onMouseOver={() => setOver(true)}
              onMouseOut={() => setOver(false)}
              onBlur={() => setFocus(false) }
              onFocus={() => setFocus(true)}
              onKeyDown={disabled ? () => {} : e => { if (e.key === 'Backspace')onChange(''); }}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default EAA_Date;
